var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedQuarterCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 69,
    viewBox: "0 0 78 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.3747 56.6719C130.496 86.2715 204.072 60.7466 233.672 -0.37468C263.272 -61.496 237.747 -135.072 176.625 -164.672C115.504 -194.272 41.9277 -168.747 12.3281 -107.625C-17.2715 -46.504 8.25341 27.0723 69.3747 56.6719ZM148.102 -105.857C176.779 -92.0182 188.696 -57.4981 174.857 -28.8211C161.018 -0.144043 126.498 11.7727 97.8211 -2.06607C69.1441 -15.9049 57.2273 -50.425 71.0661 -79.102C84.9818 -107.779 119.425 -119.773 148.102 -105.857Z",
    fill: "#FB5950"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedQuarterCircle);
export default __webpack_public_path__ + "static/media/redQuarterCircle.80e2a87dd999ddf44dac10f7b1553adc.svg";
export { ForwardRef as ReactComponent };